import React from 'react';
import { Box, Fade } from '@mui/material';
import MDButton from 'components/MDButton';
import {
  AddCircleOutline,
  DeleteSweepOutlined,
  FlashOnOutlined,
  PlaylistAddOutlined
} from '@mui/icons-material';
import { useAutomationContext } from '../context/AutomationContext';
import ActionCard from '../components/ActionCard';
import { EmptyState } from '../components/StepSection';
import { dangerText } from '../styles/wizardSx';

function ActionsStep() {
  const { state, actions } = useAutomationContext();

  const handleAddAction = () => {
    const newAction = {
      type: '',
      parameters: {},
      timeDelay: {
        enabled: false,
        days: 0,
        hours: 0,
        minutes: 0
      }
    };
    actions.addAction(newAction);
  };

  const handleUpdateAction = (index, updates) => {
    actions.updateAction(index, updates);
  };

  const handleRemoveAction = (index) => {
    actions.removeAction(index);
  };

  const handleClearAll = () => {
    actions.setActions([]);
  };

  if (state.actions.length === 0) {
    return (
      <EmptyState
        icon={<FlashOnOutlined />}
        title="No actions configured yet"
        description="Add actions to define what happens when your automation triggers."
        action={
          <MDButton
            variant="gradient"
            color="info"
            startIcon={<PlaylistAddOutlined />}
            onClick={handleAddAction}
          >
            Add Your First Action
          </MDButton>
        }
      />
    );
  }

  return (
    <Box>
      {state.actions.map((action, index) => (
        <Fade in key={index} timeout={300 + index * 100}>
          <Box sx={{ mb: 2 }}>
            <ActionCard
              action={action}
              index={index}
              onUpdate={(updates) => handleUpdateAction(index, updates)}
              onRemove={() => handleRemoveAction(index)}
            />
          </Box>
        </Fade>
      ))}

      <Box sx={{ display: 'flex', gap: 2, mt: 3 }}>
        <MDButton
          variant="gradient"
          color="info"
          startIcon={<AddCircleOutline />}
          onClick={handleAddAction}
        >
          Add Action
        </MDButton>

        <MDButton
          variant="text"
          color="error"
          startIcon={<DeleteSweepOutlined />}
          onClick={handleClearAll}
          sx={(theme) => ({ color: dangerText(theme) })}
        >
          Clear All Actions
        </MDButton>
      </Box>
    </Box>
  );
}

export default ActionsStep;
